import { render, staticRenderFns } from "./ProductsResults.vue?vue&type=template&id=2530a6f1&lang=pug&"
import script from "./ProductsResults.vue?vue&type=script&lang=js&"
export * from "./ProductsResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports